export default __webpack_public_path__ + "static/media/airports-authority.6d588c78.png";